import NavList from '../primitives/NavList';
import { NavNode } from '../types';
import SidebarGroup, { getRoutesFromNodes } from './SidebarGroup';
import SidebarLinkItem from './SidebarLinkItem';

type SidebarNavProps = {
	size?: 'default' | 'collapsed';
	navNodes: NavNode[];
	gap?: 'sm' | 'default';
	onExpandSidebar?: () => void;
	groupId?: string;
};

const SidebarNav = ({
	navNodes,
	size,
	gap = 'default',
	onExpandSidebar,
	groupId,
}: SidebarNavProps) => {
	return (
		<NavList
			bordered={gap === 'sm'}
			gap={gap}
		>
			{navNodes.map((node) => {
				if (node.type === 'link') {
					return (
						<SidebarLinkItem
							key={node.to}
							text={node.text}
							to={node.to}
							tone={node.tone}
							icon={node.icon}
							size={size}
							disabled={node.disabled}
							useIndicator={node.useIndicator}
							groupId={groupId}
						/>
					);
				}

				return (
					<SidebarGroup
						key={node.text}
						text={node.text}
						icon={node.icon}
						size={size}
						navNodes={node.children}
						childRoutes={getRoutesFromNodes(node.children)}
						onExpandSidebar={onExpandSidebar}
					>
						<SidebarNav
							navNodes={node.children}
							size={size}
							gap='sm'
							groupId={node.text}
						/>
					</SidebarGroup>
				);
			})}
		</NavList>
	);
};

export default SidebarNav;
